import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DialogFrame } from "component/shared/dialog-frame";
import { OutlinedButton } from "component/shared/outlined-button";
import { styles } from "./style";

interface OwnProps {
	open: boolean;
	onSwitch: () => void;
	onCancel: () => void;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/**
 * "Switch to Standard Search?" The Search Agent requires Smart Search, so moving a saved Smart
 * Search or Both setting to Standard turns the Search Agent off. Closing the modal any way but
 * the switch button keeps the previous selection.
 */
const Component: React.FC<Props> = ({ classes = {}, open, onSwitch, onCancel }) => (
	<DialogFrame
		open={open}
		onClose={onCancel}
		title="Switch to Standard Search?"
		titleId="switch-to-standard-title"
		titleIcon={<Icons.AlertTriangle size={24} className={classes.warningIcon} aria-hidden="true" />}
		aria-describedby="switch-to-standard-body"
		actions={
			<>
				<OutlinedButton onClick={onCancel}>
					Cancel
				</OutlinedButton>
				<Mui.Button variant="contained" color="primary" onClick={onSwitch}>
					Switch to Standard
				</Mui.Button>
			</>
		}
	>
		<Mui.Typography id="switch-to-standard-body" className={classes.text}>
			The Search Agent requires Smart Search. If you switch to Standard Search, the Search Agent will be turned off and website visitors won't be able to use it.
		</Mui.Typography>
	</DialogFrame>
);

export const SwitchToStandardDialog = withStyles(Component, styles);
